import { useState } from 'react';
import { ContextName } from './contextName';

export const AccuracyEnum = {
  IP_STACK: 'IP_STACK',
  BROWSER: 'BROWSER',
};

export const StatusEnum = {
  EMPTY: 'EMPTY',
  FULFILLED: 'FULFILLED',
  LOADING: 'LOADING',
};

export const locationState = () => {
  const [locationAccuracy, setLocationAccuracy] = useState();
  const [locationName, setLocationName] = useState();
  const [locationStatus, setLocationStatus] = useState(StatusEnum.LOADING);
  const [browserGeoQueryable, setBrowserGeoQueryable] = useState(false);
  const [coords, setCoords] = useState({
    latitude: undefined,
    longitude: undefined,
  });

  const updateAccuracy = (accuracy) => {
    if (AccuracyEnum[accuracy]) {
      setLocationAccuracy(accuracy);
    }
  };

  const updateCoords = ({ latitude, longitude, accuracy }) => {
    setCoords({ latitude, longitude });

    if (latitude && longitude) {
      setLocationStatus(StatusEnum.FULFILLED);
    } else {
      setLocationStatus(StatusEnum.EMPTY);
    }

    if (accuracy) {
      updateAccuracy(accuracy);
    }
  };

  const updateLocationName = ({
    locationName: updatedLocationName,
    accuracy,
  }) => {
    setLocationName(updatedLocationName);
    if (accuracy) {
      updateAccuracy(accuracy);
    }
  };

  const updateBrowserGeoQueryable = (browserGeoQueryableProp) => {
    setBrowserGeoQueryable(browserGeoQueryableProp);
  };

  return {
    [ContextName.LOCATION.NAME]: locationName,
    [ContextName.LOCATION.LATITUDE]: coords.latitude,
    [ContextName.LOCATION.LONGITUDE]: coords.longitude,
    [ContextName.LOCATION.UPDATE_COORDS]: updateCoords,
    [ContextName.LOCATION.UPDATE_NAME]: updateLocationName,
    [ContextName.LOCATION.ACCURACY]: locationAccuracy,
    [ContextName.LOCATION.STATUS]: locationStatus,
    [ContextName.LOCATION.BROWSER_GEO_QUERYABLE]: browserGeoQueryable,
    [ContextName.LOCATION
      .UPDATE_BROWSER_GEO_QUERYABLE]: updateBrowserGeoQueryable,
  };
};
